<ng-template>
    <div #wrapper class="actions-wrapper" (clickOutside)="closeWhenClickedOutside($event)">
        <fa-icon class="actions-trigger" [icon]="faEllipsisH" (click)="toggle()"></fa-icon>
        <div class="actions-menu mpro-box" *ngIf="isOpen" [ngStyle]="{'right.px': x, 'top.px': y}">
            <ng-content></ng-content>
        </div>
    </div>
</ng-template>